import { Office } from '@models/company/office.model';
import { ColumnTypeOption } from '@import/interfaces';

export const officeToOption = (office: Office): ColumnTypeOption => {
    return {
        label: office.name,
        value: office.id.toString(),
    };
};
